<template>
  <div class="page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/pc/index' }">PC网站</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/pc/price' }">产品价格</el-breadcrumb-item>
      <el-breadcrumb-item>编辑产品价格</el-breadcrumb-item>
      <el-breadcrumb-item>{{this.pageForm.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <el-form class="middle-form" ref="formRef" :model="pageForm" label-width="120px">
        <el-form-item label="排序">
          <el-input type="number" v-model="pageForm.sort" placeholder="数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="pageForm.title" placeholder="请输入产品项目名称"></el-input>
        </el-form-item>
        <el-form-item label="包含功能">
          <el-input v-model="pageForm.content" type="textarea" :rows="2" placeholder="请输入包含功能"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="pageForm.mark" type="textarea" :rows="2"></el-input>
        </el-form-item>
        <el-form-item label="月费">
          <el-input type="number" v-model="pageForm.monthly" placeholder="请输入该项目的使用月费"></el-input>
        </el-form-item>
        <el-form-item label="年费">
          <el-input type="number" v-model="pageForm.annual" placeholder="请输入该项目的使用年费"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">修 改</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    return {
      pageForm: {
        id: this.$route.params.id,
        sort: 0,
        title: '',
        content: '',
        mark: '',
        monthly: 0.00,
        annual: 0.00
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/pc-price', { params: { id: this.$route.params.id } })
      if (res.status === 200) {
        this.pageForm.sort = res.data.sort
        this.pageForm.title = res.data.title
        this.pageForm.content = res.data.content
        this.pageForm.mark = res.data.mark
        this.pageForm.monthly = res.data.monthly
        this.pageForm.annual = res.data.annual
      } else {
        this.$message.error(res.msg)
      }
    },
    async onSubmit () {
      if (!this.pageForm.title) {
        this.$message.error('请填写项目名称')
        return false
      }
      if (!this.pageForm.content) {
        this.$message.error('请填写项目包含功能')
        return false
      }
      const { data: res } = await this.$http.put('/pc-price', this.pageForm)
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.$router.push('/admin/apps/pc/price')
      } else {
        this.$message.error(res.msg)
      }
    },
    cancel () {
      this.$router.push('/admin/apps/pc/price')
    }
  }
}
</script>

<style scoped>
.middle-form{
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}
/deep/.el-radio{
  margin-bottom: 14px;
}
</style>
